import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ReadinessError } from '../../shared';
import Caps from '../../blocks/caps/Caps';

import './page-error.scss';

import compassBg from './static/img/compass__bg.svg';
import compassArrow from './static/img/compass__arrow.svg';
import arrowTop from './static/img/arrow_top.svg';

class NotFound extends Component {
  static contextTypes = { readiness: PropTypes.object.isRequired };

  componentWillMount() {
    this.context.readiness.ready(this, new ReadinessError(404));
  }

  render() {
    return (
      <div className="page-error">
        <div className="page-error__icon">
          <img src={compassBg} className="page-error__icon_bg" alt="" />
          <img src={compassArrow} className="page-error__icon_arrow" alt="" />
        </div>
        <div className="page-error__reason text_center">
          <Caps>
            <div className="caps-body">Ошибка 404</div>
          </Caps>
        </div>
        <div className="page-error__desc">Упс! Страница не найдена.</div>
        {this.props.hint && (
          <div className="page-error__arrow page-error__arrow_top">
            <div>Воспользуйтесь меню</div>
            <img src={arrowTop} alt="" />
          </div>
        )}
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/404/NotFound.js